import { ReactNode, useState } from "react";
import { ChevronDown } from "lucide-react";

interface PlanReviewMarkedIncorrectGroupProps {
	count: number;
	/** True when the findings are also shown in their normal place in the list. */
	isShownInPlace: boolean;
	onToggleShownInPlace: () => void;
	/** The findings of the group, rendered by the screen with its own row or card. */
	children: ReactNode;
}

/**
 * Collapsed group at the end of a findings list with the findings that the applicant marked as
 * Incorrect. These findings still block the approval, so they stay visible here until the reviewer
 * decides. "Show in place" also shows them in their normal place in the list.
 */
const PlanReviewMarkedIncorrectGroup = ({
	count,
	isShownInPlace,
	onToggleShownInPlace,
	children
}: PlanReviewMarkedIncorrectGroupProps) => {
	const [isOpen, setIsOpen] = useState(false);

	if (count === 0) return null;

	return (
		<div className="prmig">
			<div className="prmig-head">
				<button type="button" className="prmig-toggle" onClick={() => setIsOpen(open => !open)} aria-expanded={isOpen}>
					Marked incorrect ({count})
					<ChevronDown size={16} className={`prmig-chevron${isOpen ? " prmig-chevron-open" : ""}`} />
				</button>
				<button type="button" className="prmig-place-btn" onClick={onToggleShownInPlace}>
					{isShownInPlace ? "Move back to collapsed group" : "Show in place"}
				</button>
			</div>
			{isOpen && <div className="prmig-list">{children}</div>}
		</div>
	);
};

export default PlanReviewMarkedIncorrectGroup;
